<template>
  <div class="card">
    <img :src="props.data?.materialPhoto || ''" @error="setDefaultImage" />
    <div class="right">
      <div class="nameBox">
        <p style="flex: 1">
          {{ props.data.materialName }}
        </p>
        <p style="font-weight: 600">X{{ props.data.quantity }}</p>
      </div>
      <div>
        <div
          class="status"
          :style="materialStatus(props.data.applyStatus).boxStyle"
        >
          <p>{{ materialStatus(props.data.applyStatus).name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  MaterialRedeemDetailResp,
  MaterialRedeemResp
} from '@/model/score/score'
import { materialStatus } from '@/views/score/utils/status'
import img_failed from '@/assets/images/score/img_failed.png'
const setDefaultImage = (event) => {
  event.target.src = img_failed
}
const props = defineProps<{ data: MaterialRedeemDetailResp }>()
</script>

<style scoped lang="less">
.card {
  display: flex;
  flex-direction: row;
  background: #fff;
  padding: 17px 11px;
  > img {
    width: 95px;
    height: 95px;
  }
  .right {
    margin-left: 11px;
    display: flex;
    flex-direction: column;
    flex: 1;
    .nameBox {
      justify-content: space-between;
      display: flex;
      flex-direction: row;
      align-items: center;
      > p {
        color: rgba(60, 60, 60, 1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限制显示 2 行 */
        overflow: hidden;
      }
    }
    > div {
      display: flex;
      flex-direction: row;
      margin-top: 11px;
      .status {
        border-radius: 3px;
        padding: 3px 4px;
        font-size: 12px;
      }
    }
  }
}
</style>
